<button
  type="button"
  class="btn btn-menu capitalize"
  [disabled]="disabled"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  [matMenuTriggerFor]="multiSelectMenu"
>
  {{ selectedSet.size | i18nPlural: buttonText | craftTerm: { count: selectedSet.size } }}
  <craft-icon class="svg-icon text-size-11 icon-arrow" name="arrows--arrow-head-down-sm"></craft-icon>
  <craft-icon
    class="svg-icon icon-remove text-size-8"
    matTooltip="Remove filter"
    matTooltipPosition="above"
    (click)="removeFilter($event)"
    name="general--close-sm"
  ></craft-icon>
</button>

<craft-icon
  class="svg-icon icon-clear text-size-9"
  matTooltip="Clear filter"
  matTooltipPosition="above"
  (click)="clearAndApply()"
  name="general--close-sm"
></craft-icon>

<mat-menu #multiSelectMenu="matMenu">
  <ng-template matMenuContent="">
    <div class="menu-search mat-mdc-menu-item d-flex align-items-center shrink-0">
      <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
      <input
        type="text"
        #searchInput
        (click)="$event.stopPropagation()"
        [placeholder]="searchPlaceholder"
        [formControl]="searchControl"
      />
    </div>

    <div class="menu-scroll">
      <div
        mat-menu-item=""
        class="item-checkbox"
        *ngFor="let user of filteredItems | async | slice: 0 : 100; trackBy: identify"
        (click)="$event.stopPropagation()"
        craftDisableFocus=""
      >
        <mat-checkbox
          [checked]="selectedSet.has(user.id)"
          (change)="selectItem(user)"
          labelPosition="after"
          class="checkbox-black small"
        >
          <span class="d-inline-flex align-items-center w-100">
            <craft-user-icon class="d-flex shrink-0 mr-8" [user]="user"></craft-user-icon>
            <span class="ellipsis user-name mr-4">{{ user | fullName }}</span>
            <span class="ellipsis company-name" *ngIf="user.companyName">{{ user.companyName }}</span>
          </span>
        </mat-checkbox>
      </div>
    </div>

    <div class="dropdown-footer">
      <button (click)="clearSelected($event)" type="button" class="btn">Clear</button>
    </div>
  </ng-template>
</mat-menu>
